import { HttpMethod } from '../methods';
import { UrlConstant } from '../../Core/Interfaces/interfaces';

export const GET_LANGUAGES: UrlConstant = { path: '/languages/get', method: HttpMethod.GET };
export const GET_SPEECH_LANGUAGES: UrlConstant = { path: '/languages/getSpeechLanguages', method: HttpMethod.GET };
export const GET_SPEAKING_LANGUAGES: UrlConstant = { path: '/languages/getSpeakingLanguages', method: HttpMethod.GET };
export const SET_TRANSLATION_LANGUAGES: UrlConstant = { path: '/languages/changeTranslationLanguages', method: HttpMethod.POST };
export const SET_SPEAKER_LANGUAGE: UrlConstant = { path: '/languages/changeSpeakerLanguage', method: HttpMethod.POST };
